export interface NotifyMessageModel {
    id?: string;
    _id?: string;
    idUserSender: string;
    idUserReceiver: string;
    message: string;
    dataInserimento: Date;
    flagLetto?: boolean;
    type: NotifyType;
    dataValidita?: Date;
    extraData?: any;
}

export enum NotifyType {
    GENERICA = 'GENERICA',
    RICHIESTA_PRESENZA = 'RICHIESTA_PRESENZA',
    SPOSTAMENTO_SALA = 'SPOSTAMENTO_SALA',
    CAMBIO_PRENOTAZIONE = 'CAMBIO_PRENOTAZIONE',
    INFO_DESK = 'INFO_DESK',
    EVENTO_AZIENDALE = 'EVENTO_AZIENDALE',
    RIMOZIONE_PRENOTAZIONE = 'RIMOZIONE_PRENOTAZIONE',
    CEDI_POSTO = 'CEDI_POSTO',
    RICHIESTA_ABILITAZIONE_SEDE = 'RICHIESTA_ABILITAZIONE_SEDE',
    ESITO_ABILITAZIONE_SEDE = 'ESITO_ABILITAZIONE_SEDE',
    /** Sollecito di sistema: extraData.prenotazioni = id delle prenotazioni ancora da confermare */
    CONFERMA_PRESENZA = 'CONFERMA_PRESENZA'
}

export const NOTIFY_TYPE_LABEL: Record<string, string> = {
    [NotifyType.GENERICA]: 'Avviso',
    [NotifyType.RICHIESTA_PRESENZA]: 'Richiesta di presenza',
    [NotifyType.SPOSTAMENTO_SALA]: 'Richiesta di spostamento',
    [NotifyType.CAMBIO_PRENOTAZIONE]: 'Cambio prenotazione',
    [NotifyType.INFO_DESK]: 'Info postazione',
    [NotifyType.EVENTO_AZIENDALE]: 'Evento aziendale',
    [NotifyType.RIMOZIONE_PRENOTAZIONE]: 'Prenotazione rimossa',
    [NotifyType.CEDI_POSTO]: 'Richiesta di cedere il posto',
    [NotifyType.RICHIESTA_ABILITAZIONE_SEDE]: 'Richiesta abilitazione sede',
    [NotifyType.ESITO_ABILITAZIONE_SEDE]: 'Esito abilitazione sede',
    [NotifyType.CONFERMA_PRESENZA]: 'Conferma presenza',
};